import {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'

import {STUCK_TIPS} from './lifeStoryContent'

/** "Everyone gets stuck. Try this:" overlay from the prompt screens. */
const StuckOverlay = ({close}) => {
  const cardRef = useRef(null)
  const previouslyFocusedRef = useRef(null)

  // A modal dialog has to take focus (otherwise keyboard and screen-reader
  // users are left on the page underneath) and give it back when it closes.
  useEffect(() => {
    previouslyFocusedRef.current = document.activeElement
    cardRef.current.querySelector('button').focus()

    return () => {
      if (previouslyFocusedRef.current && previouslyFocusedRef.current.focus)
        previouslyFocusedRef.current.focus()
    }
  }, [])

  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      event.stopPropagation()
      close()

      return
    }

    // aria-modal promises focus stays inside the dialog, so Tab wraps within
    // its focusable controls instead of escaping to the page underneath.
    if (event.key === 'Tab') {
      const focusable = cardRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
  }

  return (
    <div
      aria-labelledby='stuck-title'
      aria-modal='true'
      className='ls-overlay'
      role='dialog'
      onClick={event => event.target === event.currentTarget && close()}
      onKeyDown={handleKeyDown}
    >
      <div className='ls-overlay-card' ref={cardRef}>
        <h3 id='stuck-title'>Everyone gets stuck. Try this:</h3>
        <ul>
          {STUCK_TIPS.map(tip => <li key={tip}>{tip}</li>)}
        </ul>
        <button className='ls-btn ls-btn-primary' onClick={close}>Back to my story</button>
      </div>
    </div>
  )
}

StuckOverlay.propTypes = {
  close: PropTypes.func.isRequired
}

export default StuckOverlay
